// assets/collapsible-drawer.js
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('ProductCollapsibleDrawer');
  const drawerTitle = document.querySelector('.product-collapsible-drawer__title');
  const drawerContent = document.getElementById('ProductCollapsibleDrawerContent');
  const drawerDismissers = document.querySelectorAll('[data-drawer-dismiss]');

  function openDrawer(blockId, blockHeading) {
    drawerTitle.innerText = blockHeading || '';

    // inject all templates (all blocks)
    const templates = document.querySelectorAll('template[id^="BlockContent-"]');
    const accordionContainer = drawerContent.querySelector('#DrawerAccordion');
    accordionContainer.innerHTML = '';

    templates.forEach((tpl) => {
      const clone = tpl.content.cloneNode(true);
      accordionContainer.appendChild(clone);
    });

    // open the clicked one
    const targetItem = accordionContainer.querySelector(`[data-accordion-id="${blockId}"]`);
    if (targetItem) {
      const summary = targetItem.querySelector('.drawer-accordion__summary');
      const panel = targetItem.querySelector('.drawer-accordion__panel');
      summary.setAttribute('aria-expanded', 'true');
    //   panel.style.maxHeight = panel.scrollHeight + 'px';
      panel.style.maxHeight = 'fit-content';
    }

    // activate drawer
    drawer.setAttribute('aria-hidden', 'false');
    drawer.dataset.drawerOpen = 'true';
    document.body.classList.add('drawer-open');

    // add accordion toggling logic
    setupAccordion(accordionContainer);
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.dataset.drawerOpen = 'false';
    document.body.classList.remove('drawer-open');
    drawerContent.querySelector('#DrawerAccordion').innerHTML = '';
  }

  drawerDismissers.forEach(el => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // delegate trigger clicks
  document.body.addEventListener('click', function (e) {
    const trigger = e.target.closest('.product__collapsible-trigger');
    if (!trigger) return;
    const blockId = trigger.dataset.collapsibleBlockId;
    const heading = trigger.dataset.collapsibleHeading;
    openDrawer(blockId, heading);
  });

  // accordion logic
  function setupAccordion(container) {
    const summaries = container.querySelectorAll('.drawer-accordion__summary');
    summaries.forEach((summary) => {
      summary.addEventListener('click', function () {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // collapse all others
        summaries.forEach((s) => s.setAttribute('aria-expanded', 'false'));
        container.querySelectorAll('.drawer-accordion__panel').forEach((p) => (p.style.maxHeight = null));

        // expand clicked
        if (!isExpanded) {
          this.setAttribute('aria-expanded', 'true');
          const panel = this.nextElementSibling;
        //   panel.style.maxHeight = panel.scrollHeight + 'px';
          panel.style.maxHeight = 'fit-content';
        }
      });
    });
  }
});
